module.exports = __webpack_public_path__ + "assets/img/img23.a06f4f47.png";